import loadable from '@loadable/component';
export const manifest = {
  SmeStickyTable: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeStickyTable";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeStickyTable" */
          './sticky-table'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./sticky-table");
            }

            return eval('require.resolve')("./sticky-table");
          }

        }, {
          resolveComponent: m => m.SmeStickyTable
        })
      }
    }
  },
  'SmeStickyTable.Header': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeStickyTableHeader";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeStickyTableHeader" */
          './sticky-table-header'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./sticky-table-header");
            }

            return eval('require.resolve')("./sticky-table-header");
          }

        }, {
          resolveComponent: mod => mod.StickyTableHeader
        })
      }
    }
  },
  'SmeStickyTable.Row': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeStickyTableRow";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeStickyTableRow" */
          './sticky-table-row'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./sticky-table-row");
            }

            return eval('require.resolve')("./sticky-table-row");
          }

        }, {
          resolveComponent: mod => mod.StickyTableRow
        })
      }
    }
  }
};